/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Next_MarkerInputs */



/**
* | output |
* | --- |
* | "Go to next marker" |
*
* @param {Shortcut_Keys_Desc_Next_MarkerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_next_marker = /** @type {((inputs?: Shortcut_Keys_Desc_Next_MarkerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Next_MarkerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller au marqueur suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum nächsten Marker gehen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai al marcatore successivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейдите к следующей отметке")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al siguiente marcador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前往下一个标记点")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次のマーカーへ移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगले मार्कर पर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Vá para o próximo marcador.")
	return /** @type {LocalizedString} */ ("Go to next marker")
});